import api from 'Application/api/api';

const getInstructions = (load, cancelToken = null) =>
    api.get('/education/instructions', {
        params: {
            load,
        },
        cancelToken,
    });

export default getInstructions;
